import { render, staticRenderFns } from "./qsServiceList.vue?vue&type=template&id=4f2805b7&scoped=true&"
import script from "./qsServiceList.vue?vue&type=script&lang=js&"
export * from "./qsServiceList.vue?vue&type=script&lang=js&"
import style0 from "./qsServiceList.vue?vue&type=style&index=0&id=4f2805b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2805b7",
  null
  
)

export default component.exports